// The options of every "Applies to" menu: the groups first, then one state at a time (A to Z,
// California among them) under their own heading.

import { APPLICABILITY_GROUPS, APPLICABILITY_LABELS, type ApplicabilityValue } from "@ask-hr/core/sources";

const GROUPS = new Set<string>(APPLICABILITY_GROUPS);
const STATES = (Object.entries(APPLICABILITY_LABELS) as [ApplicabilityValue, string][]).filter(([v]) => !GROUPS.has(v));

export function ApplicabilityOptions() {
  return (
    <>
      {APPLICABILITY_GROUPS.map((v) => (
        <option key={v} value={v}>
          {APPLICABILITY_LABELS[v]}
        </option>
      ))}
      <optgroup label="One state only">
        {STATES.map(([v, l]) => (
          <option key={v} value={v}>
            {l}
          </option>
        ))}
      </optgroup>
    </>
  );
}
